export default class AccountSettingsController {
    /** @ngInject */
    constructor(EventEmitter) {
        this.eventEmiter = EventEmitter;
    }
}



// WEBPACK FOOTER //
// ./app/components/account-settings/account-settings.controller.js